import React, { useEffect } from "react";
import { X } from "lucide-react";

export const inputCls = "w-full bg-zinc-900 border border-zinc-700 focus:border-purple-500 rounded-lg px-3 py-2 text-sm text-white placeholder-zinc-500 outline-none transition";
export const labelCls = "block text-[11px] font-bold uppercase tracking-wider text-zinc-400 mb-1.5";
export const btnPrimary = "px-4 py-2 rounded-lg text-sm font-semibold bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 disabled:opacity-50 text-white transition";
export const btnGhost = "px-3 py-2 rounded-lg text-sm font-medium border border-zinc-700 hover:border-zinc-500 text-zinc-200 hover:bg-zinc-800/60 disabled:opacity-50 transition";
export const card = "rounded-xl border border-zinc-800 bg-black/40 p-4";

export function fmtDuration(seconds) {
  const s = Math.round(Number(seconds) || 0);
  if (!s) return "";
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
}

export function parseTime(text) {
  if (text === "" || text == null) return null;
  const parts = String(text).trim().split(":").map(Number);
  if (parts.some((n) => Number.isNaN(n) || n < 0)) return NaN;
  return parts.reduce((acc, n) => acc * 60 + n, 0);
}

export function videoThumb(video, width = 480) {
  if (video?.cover_image) return video.cover_image;
  if (video?.thumbnail_url) return video.thumbnail_url;
  const pid = video?.mux_playback_id || video?.playback_id;
  if (pid && (video?.mux_playback_policy || "public") !== "signed") return `https://image.mux.com/${pid}/thumbnail.jpg?width=${width}&fit_mode=smartcrop&time=2`;
  if (video?.scene_photos?.[0]) return video.scene_photos[0];
  return null;
}

export function Modal({ title, onClose, children, footer, wide = false }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") { e.stopPropagation(); onClose(); } };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center bg-black/80 p-0 sm:p-4" onMouseDown={onClose}>
      <div role="dialog" aria-modal="true" aria-label={title} onMouseDown={(e) => e.stopPropagation()}
        className={`w-full ${wide ? "sm:max-w-3xl" : "sm:max-w-lg"} max-h-[92vh] flex flex-col rounded-t-2xl sm:rounded-2xl border border-zinc-800 bg-zinc-950 shadow-2xl`}>
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-zinc-800">
          <h3 className="font-bold text-white">{title}</h3>
          <button type="button" onClick={onClose} aria-label="Close" className="p-1 rounded hover:bg-zinc-800 text-zinc-400"><X size={18} /></button>
        </div>
        <div className="p-5 overflow-y-auto space-y-4">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-zinc-800 flex flex-wrap justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}

export function EmptyState({ children }) {
  return <div className="rounded-xl border border-dashed border-zinc-800 p-6 text-center text-sm text-zinc-500">{children}</div>;
}

export function Spinner({ label = "Loading..." }) {
  return <div className="py-8 text-center text-sm text-zinc-500" role="status">{label}</div>;
}
